import { NgModule } from "@angular/core";

import { CommonModule } from "@angular/common";
import { UiModule } from "src/app/shared/ui/ui.module";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { OopsCategoriesModule } from "src/app/core/components/categories";

import { MatIconModule } from "@angular/material/icon";
import { PanelsModule } from "src/app/shared/panels/panels.module";
import { Select2Module } from "src/app/shared/ui/forms/inputs/oops-select2/select2.module";
import { FocusingModule } from "src/app/shared/ui/forms/inputs/focusing.module";
import { FormsModule } from "@angular/forms";
import { ItemsFoundModule } from "src/app/core/pipes/items-found/items-found.module";
import { DxDataGridModule } from "devextreme-angular";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { StatusBadgeModule } from "src/app/shared/ui/forms/inputs/status-badge/status-badge.module";
import { MatDividerModule } from "@angular/material/divider";
import { DataGridRowNumberModule } from "src/app/core/pipes/datagrid-rownumber/datagrid-rownumber.module";
import { AlertBarModule } from "src/app/shared/layout/alertbar";
import { NonNegativeNumberModule } from "src/app/shared/ui/forms/inputs/non-negative-number/non-negative-number.module";
import { FreezingTabModule } from "src/app/shared/ui/forms/inputs/freezing-tab/freezing-tab.module";
import { StatusColorDropdownModule } from "src/app/shared/ui/forms/inputs/status-color-dropdown/status-color-dropdown.module";
import { PaymentDefinitionComponent } from "./payment-definition.component";
import { PaymentDefinitionRoutingModule } from "./payment-definition-routing.module";
import { FormOfPaymentTypeSearchComponent } from "./form-of-payment-type-search/form-of-payment-type-search.component";
import { FormOfPaymentTypeSearchResultsComponent } from "./form-of-payment-type-search/form-of-payment-type-search-results/form-of-payment-type-search-results.component";
import { FormOfPaymentTypeSearchCriteriaComponent } from "./form-of-payment-type-search/form-of-payment-type-search-criteria/form-of-payment-type-search-criteria.component";
import { FormOfPaymentTypeSortComponent } from "./form-of-payment-type-sort/form-of-payment-type-sort.component";
import { FormOfPaymentSortComponent } from "./form-of-payment-sort/form-of-payment-sort.component";
import { FormOfPaymentIssuerSearchComponent } from "./form-of-payment-issuer/search/form-of-payment-issuer-search.component";
import { FormOfPaymentIssuerSearchCriteriaComponent } from "./form-of-payment-issuer/search/criteria/form-of-payment-issuer-search-criteria.component";
import { FormOfPaymentIssuerSearchResultsComponent } from "./form-of-payment-issuer/search/results/form-of-payment-issuer-search-results.component";
import { FormOfPaymentIssuerSortComponent } from "./form-of-payment-issuer-sort/form-of-payment-issuer-sort.component";
import { PaymentAcquirerSearchComponent } from "./payment-acquirer/search/payment-acquirer-search.component";
import { PaymentAcquirerSearchCriteriaComponent } from "./payment-acquirer/search/criteria/payment-acquirer-search-criteria.component";
import { PaymentAcquirerSearchResultsComponent } from "./payment-acquirer/search/results/payment-acquirer-search-results.component";
import { PaymentMerchantSortComponent } from "./payment-merchant-sort/payment-merchant-sort.component";
import { PaymentAcquirerSortComponent } from "./payment-acquirer-sort/payment-acquirer-sort.component";

const CoreModule = [
    CommonModule,
    FormsModule,
]

const OopsModule = [
    UiModule,
    OopsCategoriesModule,
    PanelsModule,
    Select2Module,
    FocusingModule,
    ItemsFoundModule,
    StatusBadgeModule,
    DataGridRowNumberModule,
    AlertBarModule,
    NonNegativeNumberModule,
    FreezingTabModule,
    StatusColorDropdownModule,
]

const ExternalModule = [
    NgbNavModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    DxDataGridModule,
]

@NgModule({
    declarations: [
        FormOfPaymentTypeSearchComponent,
        FormOfPaymentTypeSearchCriteriaComponent,
        FormOfPaymentTypeSearchResultsComponent,
        FormOfPaymentTypeSortComponent,
        FormOfPaymentSortComponent,

        FormOfPaymentIssuerSearchComponent,
        FormOfPaymentIssuerSearchCriteriaComponent,
        FormOfPaymentIssuerSearchResultsComponent,
        FormOfPaymentIssuerSortComponent,

        PaymentAcquirerSearchComponent,
        PaymentAcquirerSearchCriteriaComponent,
        PaymentAcquirerSearchResultsComponent,
        PaymentAcquirerSortComponent,
        PaymentMerchantSortComponent,

        PaymentDefinitionComponent
    ],
    imports: [
        CoreModule,
        OopsModule,
        ExternalModule,
        PaymentDefinitionRoutingModule
    ],
    exports: [
    ]
})
export class PaymentDefinitionModule { }
